const Dumbbell = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M15.3917 13.6288V10.6467L17.4541 10.6539V13.6361L15.3917 13.6288Z" fill="#D95E5E" />
      <path d="M15.3917 10.6467V9.30983L17.4541 9.31709V10.6539L15.3917 10.6467Z" fill="#BE5252" />
      <path d="M15.3917 13.6288V10.6467L8.07879 10.6385L8.07879 13.6206L15.3917 13.6288Z" fill="#F06767" />
      <path d="M5.4541 13.5914L5.4541 10.6093L8.07879 10.6385L8.07879 13.6206L5.4541 13.5914Z" fill="#D95E5E" />
      <path d="M15.3917 10.6467V9.30983L8.07879 9.30171L8.07879 10.6385L15.3917 10.6467Z" fill="#D95E5E" />
      <path d="M5.4541 10.6093L5.4541 9.27246L8.07879 9.30171L8.07879 10.6385L5.4541 10.6093Z" fill="#BE5252" />
      <path
        d="M18.3167 5.25684L19.3122 5.25684C19.9919 5.25684 20.543 5.83066 20.543 6.53851V15.9752C20.543 16.683 19.9919 17.2568 19.3122 17.2568H18.3167C17.637 17.2568 17.0859 16.683 17.0859 15.9752V6.53851C17.0859 5.83066 17.637 5.25684 18.3167 5.25684Z"
        fill="#F06767"
      />
      <path
        d="M21.7737 6.45683H22.7692C23.449 6.45683 24 7.03066 24 7.7385V14.7752C24 15.483 23.449 16.0568 22.7692 16.0568H21.7737C21.094 16.0568 20.543 15.483 20.543 14.7752V7.73851C20.543 7.03066 21.094 6.45683 21.7737 6.45683Z"
        fill="#F29090"
      />
      <path
        d="M5.68329 17.2568H4.6878C4.00807 17.2568 3.45703 16.683 3.45703 15.9752L3.45703 6.53851C3.45703 5.83066 4.00807 5.25684 4.6878 5.25684L5.68329 5.25684C6.36302 5.25684 6.91406 5.83066 6.91406 6.53851L6.91406 15.9752C6.91405 16.683 6.36302 17.2568 5.68329 17.2568Z"
        fill="#F06767"
      />
      <path
        d="M2.22625 16.0568H1.23077C0.551034 16.0568 -8.91365e-08 15.483 0 14.7752L8.86099e-07 7.7385C9.75235e-07 7.03066 0.551036 6.45683 1.23077 6.45683L2.22626 6.45683C2.90599 6.45683 3.45702 7.03066 3.45702 7.7385L3.45702 14.7752C3.45702 15.483 2.90599 16.0568 2.22625 16.0568Z"
        fill="#F29090"
      />
      <path
        d="M1.23078 7.01388H2.14376C2.39587 7.01388 2.60025 7.22671 2.60025 7.48925C2.60025 7.75178 2.39587 7.96461 2.14376 7.96461H1.23078C0.97867 7.96461 0.774293 7.75178 0.774293 7.48925C0.774293 7.22671 0.97867 7.01388 1.23078 7.01388Z"
        fill="#F5B7B7"
      />
      <path
        d="M5.78414 6.09042C6.02205 6.09042 6.21563 6.29076 6.21563 6.53851C6.21563 6.78625 6.02205 6.98659 5.78414 6.98659H4.43078C4.19287 6.98659 4.00049 6.78625 4.00049 6.53851C4.00049 6.29076 4.19287 6.09042 4.43078 6.09042H5.78414Z"
        fill="#F29090"
      />
      <path
        d="M19.4873 6.09042C19.7252 6.09042 19.9188 6.29076 19.9188 6.53851C19.9188 6.78625 19.7252 6.98659 19.4873 6.98659H18.134C17.8961 6.98659 17.7037 6.78625 17.7037 6.53851C17.7037 6.29076 17.8961 6.09042 18.134 6.09042H19.4873Z"
        fill="#F29090"
      />
      <path
        d="M21.7294 7.01388H22.6424C22.8945 7.01388 23.0989 7.22671 23.0989 7.48925C23.0989 7.75179 22.8945 7.96461 22.6424 7.96461H21.7294C21.4773 7.96461 21.2729 7.75179 21.2729 7.48925C21.2729 7.22671 21.4773 7.01388 21.7294 7.01388Z"
        fill="#F5B7B7"
      />
    </svg>
  );
};

export default Dumbbell;
